// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-TextField-editor-TextFieldEditor-module__container";
export { _1 as "container" }
